import { X, Download, FileText } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const CGU_URL = {
    fr: '/data/CGU/cguFr.pdf',
    en: '/data/CGU/cguEn.pdf',
};

const labels = {
    fr: {
        title: "Conditions Générales d'Utilisation",
        download: 'Télécharger',
    },
    en: {
        title: 'Terms and Conditions',
        download: 'Download',
    },
};

const CGUModal = ({ onClose }) => {
    const { language } = useLanguage();
    const lang = language === 'en' ? 'en' : 'fr';
    const pdfUrl = CGU_URL[lang];
    const t = labels[lang];

    return (
        <div className="fixed inset-0 z-[200] flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
            <div className="relative bg-white dark:bg-[#121212] rounded-3xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col overflow-hidden">
                {/* Header */}
                <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 dark:border-white/10 flex-shrink-0">
                    <div className="flex items-center gap-3">
                        <div className="p-2 bg-blue-100 dark:bg-blue-500/20 rounded-xl">
                            <FileText className="w-5 h-5 text-blue-600 dark:text-blue-400" />
                        </div>
                        <h2 className="text-lg font-bold text-gray-900 dark:text-white">{t.title}</h2>
                    </div>
                    <div className="flex items-center gap-2">
                        <a
                            href={pdfUrl}
                            download
                            className="flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-xl transition"
                        >
                            <Download className="w-4 h-4" />
                            {t.download}
                        </a>
                        <button
                            onClick={onClose}
                            className="p-2 text-gray-400 hover:text-gray-600 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-white/10 rounded-xl transition"
                            aria-label="Fermer"
                        >
                            <X className="w-5 h-5" />
                        </button>
                    </div>
                </div>

                {/* PDF viewer */}
                <div className="flex-1 overflow-hidden min-h-0">
                    <iframe
                        src={pdfUrl}
                        className="w-full h-full border-0"
                        title={t.title}
                        style={{ minHeight: '60vh' }}
                    />
                </div>
            </div>
        </div>
    );
};

export default CGUModal;
